import { gql } from "@apollo/client";

export const GET_STANDS_CURSOR = gql`
  query StandsCursor(
    $text: String
    $ee_id: ID
    $hall_id: ID
    $exclude_graphics_sent: Boolean
    $where: QueryStandsCursorWhereWhereConditions
    $whereCrafts: QueryStandsCursorWhereCraftsWhereHasConditions
    $whereEvents: QueryStandsCursorWhereEventsWhereHasConditions
    $orderBy: [QueryStandsCursorOrderByRelationOrderByClause!]
    $first: Int
    $after: String
  ) {
    standsCursor(
      text: $text
      ee_id: $ee_id
      hall_id: $hall_id
      exclude_graphics_sent: $exclude_graphics_sent
      where: $where
      whereCrafts: $whereCrafts
      whereEvents: $whereEvents
      orderBy: $orderBy
      first: $first
      after: $after
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
        total
        count
        currentPage
        lastPage
      }
      edges {
        cursor
        node {
          id
          ee_id
          hall_id
          hall_name
          exhibitor
          aquise_number
          proauf_number
          block
          corridor
          stand_number
          cad_number
          delivery_time_at
          file_stand_plan
          file_info
          file_graphic
          file_photo
          file_animation
          damageFilesCount
          comments_count
          exhibitionEvent {
            id
            title
            status
          }
          hall {
            id
            title
            ee_id
          }
          keys {
            stand_id
            number
            title
            id
          }
          crafts {
            id
            title
            subcontractor_id
            stand_id
            type
            type_icon
            status
          }
          getQRCode
          shelf_number
          shelf_user_id
          shelf_date_at
          relShelfUser {
            id
            name
            surname
          }
          relCraftCollectGraphic {
            id
            title
            type
            status
          }
          created_at
          updated_at
        }
      }
    }
  }
`;

export const GET_STAND = gql`
  query Stand($id: ID!, $ee_id: ID, $hall_id: ID) {
    stand(id: $id, ee_id: $ee_id, hall_id: $hall_id) {
      id
      ee_id
      hall_id
      hall_name
      exhibitor
      aquise_number
      proauf_number
      block
      corridor
      stand_number
      cad_number
      delivery_time_at
      file_stand_plan
      file_info
      file_graphic
      file_photo
      file_animation
      exhibitionEvent {
        id
        title
        status
      }
      hall {
        id
        title
      }
      keys {
        id
        title
        number
        stand_id
      }
      crafts {
        id
        subcontractor_id
        stand_id
        type
        status
      }
      created_at
      updated_at
    }
  }
`;


export const GET_STAND_COMMENT = gql`
  query StandComment($id: ID!) {
  comment(id: $id) {
    id
    modelable_type
    modelable_id
    content
    status
    user_id
    created_at
    updated_at
    modelable {
      ... on Stand {
        id
        stand_number
      }
    }
    relAttachments {
      id
      path
      server_name
      original_name
      extension
      size
      modelable_type
      modelable_id
      user_id
      created_at
      updated_at
    }
    relUser {
      id
      name
      surname
    }
  }
  }
`;


export const GET_STAND_COMMENTS = gql`
  query StandComments(
    $text: String
    $where: QueryCommentsWhereWhereConditions
    $orderBy: [QueryCommentsOrderByOrderByClause!]
    $first: Int
    $page: Int
  ) {
    comments(
    text: $text
    where: $where
    orderBy: $orderBy
    first: $first
    page: $page
  ) {
    paginatorInfo {
      total
      count
      currentPage
      perPage
      lastPage
    }
    data {
      id
      modelable_type
      modelable_id
      content
      status
      user_id
      created_at
      updated_at
      modelable {
        ... on Stand {
          id
          stand_number
        }
      }
      relAttachments {
        id
        path
        server_name
        original_name
        extension
        size
        modelable_type
        modelable_id
        user_id
        created_at
        updated_at
    }
    relUser {
      id
      name
      surname
     }
    }
   }
  }
`;